  <template>
  <div class="right">
    <div class="mainTop">
      <div class="underHeader">
        <img src="../../assets/img/info.png" alt />
        当前位置：
      </div>
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        style="width:50%;height: 54px;display: inline-block;line-height: 54px;"
      >
        <el-breadcrumb-item :to="{ path: '/' }">平台首页</el-breadcrumb-item>
        <el-breadcrumb-item>医药公司筛选</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 切换 -->
    <div class="rightTab">
      <div class="tab" :class="{active:nowIndex==0}" @click="titleTab(0)">可视化概览</div>
      <div class="tab" :class="{active:nowIndex==1}" @click="titleTab(1)">数据列表</div>
    </div>
    <!-- 可视化 -->
    <Visualization v-show="nowIndex===0" :initEchart="collapse"></Visualization>
    <!-- 数据列表 -->
    <div class="dataList" v-show="nowIndex===1">
      <!-- 查询 -->
      <div class="rightTop">
        <div class="title">
          <img src="@/assets/img/14.png" alt />
          <span>筛选条件</span>
        </div>
        <div class="con">
          <div class="conLeft1">
            <div class="selectBox">
              <span>时间</span>
              <el-select
                v-model="selectTime.value"
                multiple
                collapse-tags
                placeholder="请选择"
                @change="selectOne"
              >
                <el-option
                  v-for="item in selectTime.timeList"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </div>
            <div class="selectBox two">
              <span>分类1</span>
              <el-select
                v-model="selectType.value"
                multiple
                collapse-tags
                placeholder="请选择"
                @change="selectTwo"
              >
                <el-option
                  v-for="item in selectType.typeList"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </div>
            <div class="selectBox three">
              <span>分类2</span>
              <el-select
                v-model="selectType2.value"
                multiple
                collapse-tags
                placeholder="请选择"
                @change="selectThree"
              >
                <el-option
                  v-for="item in selectType2.type2"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="conLeft2">
            <div class="selectBox">
              <span>产品名称</span>
              <el-input placeholder="请输入产品名称" v-model="input" clearable @change="inputOne"></el-input>
            </div>
            <div class="selectBox">
              <span>生产单位</span>
              <el-input placeholder="请输入生产单位" v-model="input2" clearable @change="inputTwo"></el-input>
            </div>
            <div class="selectBox">
              <div class="button" @click="searchFun">查询</div>
            </div>
          </div>
        </div>
      </div>
      <!--下载 -->
      <div class="rightCenter">
        <div class="centerTit">化学药品制剂主要品种产量</div>
        <div class="centerCon">
          <div class="no">
            <span></span>
          </div>
          <div class="cueWords" v-show="hint">最多下载1000条</div>
          <div class="excel" @click="downloadTable()" @mouseenter="enter()" @mouseleave="leave()">
            <img src="@/assets/img/Excel.png" alt />
            下载数据到Excel
          </div>
        </div>
      </div>
      <!-- 表格 -->
      <div class="rightBottom">
        <div class="tabulationBottom">
          <el-table
            :data="majorList"
            style="width: 100% background:#052B4F;"
            border
            size="mini"
            :fit="true"
            :cell-style="cellStyle1"
            @row-click="getDetails1"
          >
            <af-table-column prop="time" label="时间"></af-table-column>
            <af-table-column prop="type1" label="分类1"></af-table-column>
            <af-table-column prop="type2" label="分类2"></af-table-column>
            <af-table-column prop="productname" label="产品名称"></af-table-column>
            <af-table-column prop="department" label="生产单位"></af-table-column>
            <af-table-column prop="unifiedSocialCreditCode" label="统一社会信用代码"></af-table-column>
            <af-table-column prop="spec" label="规格"></af-table-column>
            <af-table-column prop="unit" label="计量单位"></af-table-column>
            <af-table-column prop="output" label="产量"></af-table-column>
          </el-table>
        </div>
      </div>
      <!-- 分页 -->
      <div class="rightPaging">
        <el-pagination
          prev-text="上一页"
          next-text="下一页"
          background
          @current-change="handleCurrentChange"
          :current-page="currentPage4"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="totlalCount"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import api from "@/../static/common/api/api.js";
window.api = api;
import magic from "@/../static/common/magic.js";
import axios from "axios";
import Visualization from "@/components/visualization.vue";

export default {
  props: ["collapse"],
  components: {
    Visualization
  },
  data() {
    return {
      nowIndex: 0,

      typeOnes: "",
      typeTwos: "",
      times: "",
      productNames: "",
      department: "",
      offset: 0, //从多少条开始
      limit: 10, //每页多少条
      currentPage4: 1,
      totlalCount: 0, //总条数

      // 选择框
      selectTime: {
        timeList: [],
        value: []
      },
      selectType: {
        typeList: [],
        value: []
      },
      selectType2: {
        type2: [],
        value: []
      },
      input: "",
      input2: "",
      majorList: [],
      // 下载提示
      hint: false
    };
  },
  computed: {},
  methods: {
    // 首次展示
    firstShow() {
      let nowIndex1 = JSON.parse(sessionStorage.getItem("nowIndex"))
        ? JSON.parse(sessionStorage.getItem("nowIndex"))
        : 0;
      this.nowIndex = nowIndex1;
    },
    // 切换
    titleTab(val) {
      this.nowIndex = val;
    },
    //查询
    selectOne(val) {
      this.times = val.toString();
      // console.log(this.times, 999999999999);
      this.getDrugOutputData(
        this.typeOnes,
        this.typeTwos,
        this.times,
        this.productNames,
        this.department,
        this.offset,
        this.limit
      );
      // 埋点
      try {
        //LogCollection.contents["key"]="value";
        //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
        //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
        LogCollection.send(9);
      } catch (e) {}
    },
    selectTwo(val) {
      // console.log(type, 222222222222);
      this.typeOnes = val.toString();
      this.getDrugOutputData(
        this.typeOnes,
        this.typeTwos,
        this.times,
        this.productNames,
        this.department,
        this.offset,
        this.limit
      );
      // 埋点
      try {
        //LogCollection.contents["key"]="value";
        //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
        //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
        LogCollection.send(9);
      } catch (e) {}
    },
    selectThree(val) {
      // console.log(type, 222222222222);
      this.typeTwos = val.toString();
      this.getDrugOutputData(
        this.typeOnes,
        this.typeTwos,
        this.times,
        this.productNames,
        this.department,
        this.offset,
        this.limit
      );
      // 埋点
      try {
        //LogCollection.contents["key"]="value";
        //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
        //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
        LogCollection.send(9);
      } catch (e) {}
    },
    inputOne() {
      this.productNames = this.input;
      this.getDrugOutputData(
        this.typeOnes,
        this.typeTwos,
        this.times,
        this.productNames,
        this.department,
        this.offset,
        this.limit
      );
      // 埋点
      try {
        //LogCollection.contents["key"]="value";
        //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
        //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
        LogCollection.send(9);
      } catch (e) {}
    },
    inputTwo() {
      this.department = this.input2;
      this.getDrugOutputData(
        this.typeOnes,
        this.typeTwos,
        this.times,
        this.productNames,
        this.department,
        this.offset,
        this.limit
      );
      // 埋点
      try {
        //LogCollection.contents["key"]="value";
        //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
        //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
        LogCollection.send(9);
      } catch (e) {}
    },
    searchFun() {
      let _this = this;
      magic.loginOrRights(1).then(res => {
        if (!res) {
          _this.$message.error("请您登录！");
          return;
        }
        if (res && res.rights == 0) {
          _this.$message.error("请您购买！");
          return;
        }
        _this.productNames = _this.input;
        _this.department = _this.input2;
        _this.getDrugOutputData(
          _this.typeOnes,
          _this.typeTwos,
          _this.times,
          _this.productNames,
          _this.department,
          _this.offset,
          _this.limit
        );
        // 埋点
        try {
          //LogCollection.contents["key"]="value";
          //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
          //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
          LogCollection.send(9);
        } catch (e) {}
      });
    },
    // 获取时间
    getTime() {
      api.pharmaChemicalMajorTime().then(res => {
        this.selectTime.timeList = res.data;
        // console.log(res.data, "time");
      });
    },
    // 分类1
    getTypeOne() {
      api.pharmaChemicalMajorTypeOne().then(res => {
        // console.log(res.data, "type1");
        this.selectType.typeList = res.data;
      });
    },
    // 分类2
    getTypeTwo() {
      api.pharmaChemicalMajorTypeTwo().then(res => {
        // console.log(res.data, "type2");
        this.selectType2.type2 = res.data;
      });
    },

    // 分页
    handleCurrentChange(val) {
      this.offset = (val - 1) * this.limit;
      this.getDrugOutputData(
        this.typeOnes,
        this.typeTwos,
        this.times,
        this.productNames,
        this.department,
        this.offset,
        this.limit
      );
    },
    // 表格数据
    getDrugOutputData(
      typeOnes,
      typeTwos,
      times,
      productNames,
      department,
      offset,
      limit
    ) {
      //  { "typeOnes":"呼吸系统药物,泌尿系统用药,皮肤科用药","typeTwos":"软胶囊剂,冻干粉针剂", "times":"2016,2015", "productNames":"","department":"","offset":0,"limit":10}
      let parmars = {
        typeOnes,
        typeTwos,
        times,
        productNames,
        department,
        offset,
        limit
      };
      api.pharmaChemicalMajorTable(parmars).then(res => {
        this.totlalCount = res.data.total;
        this.majorList = res.data.rows;
        // console.log(typeof this.totlalCount=='string',9999999999999)
        // console.log(res.data, "你看看表格数据");
      });
    },
    // 公司高亮
    cellStyle1({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 4) {
        return `color:#3583ED;font-weight:bold;cursor: pointer;`;
      } else {
        return "";
      }
    },
    // 去搜索页
    getDetails1(row, column) {
      if (column.property == "department") {
        let companyName = row.department;
        let entId = row.uniqueCode;
        let dbcode = this.$route.query.dbcode;
        if (entId != "***" && entId != "--") {
          this.$router.push({
            path: `/enterprisesDetail`,
            query: {
              entId
            }
          });
        } else {
          this.$message.error("暂无数据!");
        }

        sessionStorage.setItem("companyName", JSON.stringify(companyName));
      }
    },
    // 下载
    enter() {
      this.hint = true;
    },
    leave() {
      this.hint = false;
    },
    downloadTable() {
      magic.loginOrRights(1).then(res => {
        if (!res) {
          this.$message.error("请您登录！");
        } else {
          api.weighterRights(1).then(res => {
            if (res.data) {
              axios({
                method: "post",
                url: window.medicineUrl + "/medicineSearch/downDrugOutputData", // 请求地址
                data: {
                  typeOnes: this.typeOnes,
                  typeTwos: this.typeTwos,
                  department: this.department,
                  times: this.times,
                  productNames: this.productNames,
                  offset: this.offset,
                  limit: this.limit
                },
                responseType: "arraybuffer",
                observe: "response"
              }).then(res => {
                const fileName = "化学药品制剂主要品种产量.xlsx";
                let blob = new Blob([res.data], {
                  type:
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                });
                if ("download" in document.createElement("a")) {
                  // 非IE下载
                  const elink = document.createElement("a");
                  elink.download = fileName;
                  elink.style.display = "none";
                  elink.href = URL.createObjectURL(blob);
                  document.body.appendChild(elink);
                  elink.click();
                  URL.revokeObjectURL(elink.href); // 释放URL 对象
                  document.body.removeChild(elink);
                } else {
                  // IE10+下载
                  navigator.msSaveBlob(blob, fileName);
                }
              });
              // 埋点
              try {
                //LogCollection.contents["key"]="value";
                //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
                //2：收藏
                //3：下载
                //4：分享
                //5：购买
                //6：登录
                //7：注册
                //9：搜索
                //10：复制
                //11：点赞
                //12：评论
                LogCollection.send(3);
              } catch (e) {}
            } else {
              this.$message.error("请您购买！");
            }
          });
        }
      });
    },
    download(data) {
      if (!data) {
        return;
      }
      let url = window.URL.createObjectURL(new Blob([data]));
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", "excel.xlsx");
      document.body.appendChild(link);
      link.click();
    }
  },
  created() {},
  mounted() {
    this.firstShow(); //首次展示
    this.getTime(); //时间
    this.getTypeOne(); //大类1
    this.getTypeTwo(); //大类2
    this.getDrugOutputData(
      this.typeOnes,
      this.typeTwos,
      this.times,
      this.productNames,
      this.department,
      this.offset,
      this.limit
    ); //表格
  }
};
</script>
<style scoped lang="less">
@import "../../assets/less/style.less";
@import "../../assets/less/right.less";
@import "../../assets/less/moreThanThree.less";
</style>


// WEBPACK FOOTER //
// src/view/pharma/chemicalMajor.vue